// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs___Ffux","tabsList":"Tabs_tabsList__3Z1YT","divider":"Tabs_divider__2Jp8p"};